module.exports = {
  fr: {
    title: "Paiement",
    amount: "Montant à régler",
    cta: "Confirmer le paiement",
    termsBefore: "En appuyant sur Confirmer le paiement, vous acceptez nos",
    termsLink: "Conditions générales de vente",
    secure: "Paiement sécurisé par Stripe",
  },
  en: {
    title: "Payment",
    amount: "Amount due",
    cta: "Confirm payment",
    termsBefore: "By clicking Confirm payment, you accept our",
    termsLink: "Terms and conditions of sale",
    secure: "Secure payment by Stripe",
  },
  ru: {
    title: "Оплата",
    amount: "Сумма к оплате",
    cta: "Подтвердить оплату",
    termsBefore: "Нажимая «Подтвердить оплату», вы принимаете наши",
    termsLink: "Условия продажи",
    secure: "Безопасная оплата через Stripe",
  },
};
